import { useEffect, useState } from "react";
import {
  ControllerLogItemResponse,
  getControllerLog,
} from "../../../../api/controller-log";
import { TournamentResponse } from "../../../../api/tournament";
import {
  TimerLogBoxWrapper,
  TimerLogContentHeaderWrapper,
  TimerLogContentItemWrapper,
  TimerLogContentWrapper,
  TimerLogHeaderWrapper,
  TimerLogPaginationWrapper,
  TimerLogSearchWrapper,
} from "./style";
import { formatDate } from "../../../../utils/date";
import Pagination from "../../../../component/Pagination";
import { Overlay } from "../../../../styles/popup";

const TimerLogHeader = [
  "레벨 / 시간",
  "닉네임",
  "구분",
  "결제수단",
  "금액",
  "스택",
  "총스택",
  "토탈 엔트리",
  "삭제여부",
];

const TimerLog = ({
  tournamentId,
  setIsLogOpen,
  data,
}: {
  tournamentId: number;
  setIsLogOpen: (value: boolean) => void;
  data: TournamentResponse | null;
}) => {
  const [controllerLog, setControllerLog] = useState<
    ControllerLogItemResponse[]
  >([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(3);
  const limit = 8;
  const [search, setSearch] = useState("");

  const fetchControllerLog = async (targetPage: number) => {
    if (!data) return;

    try {
      const res = await getControllerLog(
        tournamentId,
        targetPage,
        limit,
        search,
      );
      setTotalPage(Math.ceil(res.totalCount / limit));
      setControllerLog(res.data);
    } catch (err) {
      console.error("Failed to fetch controller log:", err);
    }
  };

  useEffect(() => {
    fetchControllerLog(page);
  }, [page, search]);

  const onPageChange = (nextPage: number) => {
    setPage(nextPage);
  };

  if (!data) return null;

  return (
    <Overlay>
      <TimerLogBoxWrapper>
        <TimerLogHeaderWrapper>
          <div className="title">{data.title}</div>
          <div className="right">
            <TimerLogSearchWrapper>
              <input
                type="text"
                className="search-input"
                placeholder="검색어를 입력하세요."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
              <div className="search-button">
                <img
                  src="/image-web/timer-config/searchIcon.svg"
                  alt="search"
                />
              </div>
            </TimerLogSearchWrapper>
            <div className="close-button" onClick={() => setIsLogOpen(false)}>
              <img src="/image-web/log/close.svg" alt="close" />
            </div>
          </div>
        </TimerLogHeaderWrapper>
        <TimerLogContentWrapper>
          <TimerLogContentHeaderWrapper>
            {TimerLogHeader.map((item, index) => (
              <div className="title" key={index}>
                {item}
              </div>
            ))}
          </TimerLogContentHeaderWrapper>
          {controllerLog.map((item) => (
            <TimerLogContentItemWrapper key={item.id}>
              <div className="wrapper value">
                <div className="level">
                  LV.{item.level} {item.levelTime}
                </div>
                <div className="time">{formatDate(item.createdAt, true)}</div>
              </div>
              <div className="value bold">{item.nickname}</div>
              <div className="value">{item.type}</div>
              <div className="value">{item.paymentMethod}</div>
              <div className="value">{item.amount}</div>
              <div className="value">
                {item.stack ? item.stack?.toLocaleString() : ""}
              </div>
              <div className="value">
                {item.totalStack ? item.totalStack.toLocaleString() : ""}
              </div>
              <div className="value">{item.totalEntry}</div>
              <div className="value bold">
                {item.isDeleted === null ? "" : item.isDeleted ? "Y" : "N"}
              </div>
            </TimerLogContentItemWrapper>
          ))}
        </TimerLogContentWrapper>
        {totalPage > 1 && (
          <TimerLogPaginationWrapper>
            <Pagination
              currentPage={page}
              totalPages={totalPage}
              onPageChange={onPageChange}
            />
          </TimerLogPaginationWrapper>
        )}
      </TimerLogBoxWrapper>
    </Overlay>
  );
};

export default TimerLog;
